// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1PZ_N","rootCenter":"LoadMoreObserver_rootCenter__2yk4I","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3-f2D"};